import styled from "styled-components";

export const ContactContainer = styled.div`
    background-color: #434343;
    background-position: center;
    background-size: cover;
    min-height: 80vh;
    display: flex;
    flex-direction: column;
    align-items: center;
      
    text-align: center;
    @media only screen and (max-width: 600px){
        min-height: 75vh;
    }

    
  
`;

export const ContactH1 = styled.h1`
padding-top: 12px;
font-size: clamp(1rem, 10vw, 5rem);
font-family: 'Source Code Pro', monospace;
word-wrap: break-word;
color: #4AF626;
margin-bottom: 1rem;
letter-spacing: 3px;


`;
export const ContactH2 = styled.h2`
font-size: clamp(1rem, 10vw, 3rem);
font-family: 'Source Code Pro', monospace;
color: #4AF626;
margin-bottom: 1rem;
letter-spacing: 2px;
`;

export const ContactH3 = styled.h3`
font-size: clamp(1rem, 10vw, 2rem);
font-family: 'Source Code Pro', monospace;
color: #4AF626;
margin-bottom: 1rem;
letter-spacing: 2px;
a{
    color: #4AF626;  
    text-decoration: none;
}
p:hover{
    color: #fff;
    /*cursor: pointer;*/
}
@media only screen and (max-width: 600px){
    font-size: 18px;
}
`;
export const ContactH4 = styled.h4`
font-size: clamp(1rem, 10vw, 1rem);
font-family: 'Source Code Pro', monospace;
color: #4AF626;
margin-bottom: 1rem;
letter-spacing: 2px;
a:hover{
    color: #fff;
    /*cursor: pointer;*/
}
`;
